export enum SignalStage {
  NEW = 'NEW',
  IN_TESTING = 'IN_TESTING',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  TESTED = 'TESTED',
}

export enum SignalStatus {
  POTENTIAL_VULNERABILITY = 'POTENTIAL_VULNERABILITY',
  BLOCKED = 'BLOCKED',
  CONFIRMED_VULNERABILITY = 'CONFIRMED_VULNERABILITY',
  DISPROVEN_VULNERABILITY = 'DISPROVEN_VULNERABILITY',
  DUPLICATE = 'DUPLICATE',
  // Evidence still being gathered - excluded from automated attack pickup by
  // ExternalNetworkExecutionService.triggerExecutionsForExternalNetwork,
  // which only selects status: null. See schema.prisma for the full note.
  PENDING_ENRICHMENT = 'PENDING_ENRICHMENT',
  // Enrichment / PoC ended without attack eligibility. Not a post-attack
  // DISPROVEN_VULNERABILITY outcome.
  FAILED_ENRICHMENT = 'FAILED_ENRICHMENT',
}
export const SIGNAL_STAGE_VALUES = [
  SignalStage.NEW,
  SignalStage.IN_TESTING,
  SignalStage.NEEDS_REVIEW,
  SignalStage.TESTED,
] as const;

export const SIGNAL_STATUS_VALUES = [
  SignalStatus.POTENTIAL_VULNERABILITY,
  SignalStatus.BLOCKED,
  SignalStatus.CONFIRMED_VULNERABILITY,
  SignalStatus.DISPROVEN_VULNERABILITY,
  SignalStatus.DUPLICATE,
  SignalStatus.PENDING_ENRICHMENT,
  SignalStatus.FAILED_ENRICHMENT,
] as const;
